import axios from "axios";

const signupApiInstance = axios.create({
  baseURL: process.env.VUE_APP_SERVERURL,
});

const BASE_PATH = "/companies/signup";

export const signupService = {
  async checkUsername(username) {
    const response = await signupApiInstance.get(
      `/accounts/duplicateCheck/${username}`
    );
    return response.data; // true: 중복, false: 사용 가능
  },

  async ocrBusinessLicense(file, businessNumber) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("businessNumber", businessNumber);

    const response = await signupApiInstance.post(
      `${BASE_PATH}/ocr/business-license`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  async verifyBusinessNumber(businessNumber) {
    const response = await signupApiInstance.post(
      `${BASE_PATH}/verify-business-number`,
      { businessNumber }
    );
    return response.data;
  },

  async signupHospital(signupData, businessLicenseFile) {
    const formData = new FormData();
    if (businessLicenseFile) {
      formData.append("businessLicenseFile", businessLicenseFile);
    }
    formData.append("data", JSON.stringify(signupData));

    const response = await signupApiInstance.post(
      `${BASE_PATH}/hospital`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },
};

export default signupService;
